import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { Row, Col } from "reactstrap";
import Switch from "react-switch";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { API, EMPTY_DATA, defaultPageSize } from "../../../../../../config/constants";

import NoContentFound from "../../../../../common/NoContentFound";
import { PaginationWrapper } from "../../../../../common/commonPagination";
import LoaderCustom from "../../../../../common/LoaderCustom";
import DayTime from "../../../../../common/DayTimeWrapper";
import { apiErrors, notify, userDetails } from "../../../../../../helper";
import CustomDateRangeFilter from "../../../../supplierNewRequestHistory/common/CustomDateRangeFilter ";
import Button from "../../../../../layout/Button";
import axiosHelper from "../../../../../../axiosHelper";
import { reactLocalStorage } from "reactjs-localstorage";
import { setSelectedRowForPagination } from "../../../../../simulation/actions/Simulation";
import Toaster from "../../../../../common/Toaster";
import _ from "lodash";
import { ApplyPendingForKys2 } from ".";


const userDetail = userDetails();
const userEmployeeId = userDetail?.EmployeeId;
const gridOptions = {};

const PendingForApprovalKys2ListTab = (props) => {
    const dispatch = useDispatch();

    const permissionsKys2 = useContext(ApplyPendingForKys2);

    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState({
        pageSize10: true,
        pageSize50: false,
        pageSize100: false,
    });
    const [filter, setFilter] = useState("");
    const [noData, setNoData] = useState(false);
    const [pageLoader, setPageLoader] = useState(false);
    const [globalTake, setGlobalTake] = useState(defaultPageSize);
    const [gridApi, setGridApi] = useState(null); // DONT DELETE THIS STATE , IT IS USED BY AG GRID
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [currentRowIndex, setCurrentRowIndex] = useState(0);
    const [excelStartDate, setExcelStartDate] = useState("");
    const [excelEndDate, setExcelEndDate] = useState("");
    const [pendingForApprovalKys2ListData, setPendingForApprovalKys2ListData] = useState(null);


    const [dataCount, setDataCount] = useState(0);

    const onBtPrevious = () => {
        if (currentRowIndex >= 10) {
            const previousNo = Math.max(0, currentRowIndex - 10);
            setCurrentRowIndex(previousNo);
            setPageNo((prevPageNo) => Math.max(1, prevPageNo - 1));
            let params = { pageNo: pageNo - 1, pageSize: globalTake }
            getPendingForApprovalKys2List(params); // Fetch data for the previous page
        }
    };

    const onBtNext = () => {
        if (
            (pageSize.pageSize50 &&
                pageNo >= Math.ceil(pendingForApprovalKys2ListData?.TotalItems / 50)) ||
            (pageSize.pageSize100 &&
                pageNo >= Math.ceil(pendingForApprovalKys2ListData?.TotalItems / 100))
        ) {
            return false;
        }

        if (currentRowIndex < pendingForApprovalKys2ListData?.TotalItems - 10) {
            const nextNo = currentRowIndex + 10;
            setCurrentRowIndex(nextNo);
            setPageNo((prevPageNo) => prevPageNo + 1);

            // Retrieve sorting information
            const sortModel = gridApi.getSortModel();
            const sort = sortModel.length > 0 ? sortModel[0].sort : "ASC";
            const colId = sortModel.length > 0 ? sortModel[0].colId : null;

            let params = { pageNo: pageNo + 1, pageSize: globalTake, SortOrder: sort, SortBy: colId }
            getPendingForApprovalKys2List(params);
        }
    };

    async function excelDownload(params) {
        try {
            const response = await axiosHelper.post(`${API.getPendingForApprovalKys2ListExcelExport}`
                , {
                    EmployeeId: params.EmployeeId,
                    SearchText: params?.SearchText
                    // PlantCode: params?.PlantCode,
                    // CategoryCode: params?.CategoryCode,
                    // Status: params?.Status,
                    // RequestFromDate: params?.fromDate || null,
                    // RequestToDate: params?.toDate || null,                
                }
            );

            const fileUrl = response.data.Data[0];

            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            if (error.response.status === 401) {
                apiErrors(error)
            }else{
                throw error;
            }
           
        }
    }

    const handleExcelDownload = async (filters) => {
        const requestFromDateExcel = excelStartDate ? excelStartDate : null;
        const requestToDateExcel = excelEndDate ? excelEndDate : null;

        const userDetail = userDetails();
        const userEmployeeId = userDetail?.EmployeeId;
        try {
            // Call the excelDownload service function with the required parameters
            const paramsForExcel = {
                EmployeeId: parseInt(userEmployeeId, 10),
                CategoryCode: filters?.CategoryCode,
                PlantCode: filters?.PlantCode,
                Status: filters?.Status,
                fromDate: requestFromDateExcel || null,
                toDate: requestToDateExcel || null,
                SearchText: filter?.supplierName,
            };
            await excelDownload(paramsForExcel);
        } catch (error) {
            if (error.response.status === 401) {
                apiErrors(error)
            }
        }
    };

    const getPendingForApprovalKys2List = (params) => {
        let { pageNo, pageSize, SearchText, SortBy, SortOrder, requestFromDate, requestToDate } = params;

        axiosHelper.get(props?.isDelegated ? API.getPendingForApprovalKys2ListDelegated : API.getPendingForApprovalKys2List, {
            params: {
                EmployeeId: userEmployeeId,
                // EmployeeId: 291197,
                page: pageNo,
                pageSize: pageSize,
                SearchText: SearchText,
                SortBy: SortBy,
                SortOrder: SortOrder,
                isDelegated:props?.isDelegated,
                RequestFromDate: requestFromDate,
                RequestToDate: requestToDate,
            }, // Assuming filter contains necessary query parameters
        }).then(res => {
            if (res.data.IsSuccessful) {
                setPendingForApprovalKys2ListData(res?.data?.Data)
            }
        }).catch((error) => {
            if (error.response.status === 401) {
                apiErrors(error)
            } else {
                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage);
                }
            }


        });
    }
    useEffect(() => {
        getPendingForApprovalKys2List({ pageNo, pageSize: defaultPageSize })
    }, [])


    const onFilterChanged = () => {
        const filterModel = gridApi.getFilterModel();

        const requestDateFilter = filterModel.applyDate;
        const requestFromDate = formatDateHavells(
            requestDateFilter ? requestDateFilter?.dateFrom : null
        );
        setExcelStartDate(requestFromDate);
        const requestToDate = formatDateHavells(
            requestDateFilter ? requestDateFilter?.dateTo : null
        );
        setExcelEndDate(requestToDate);


        let params = { pageNo, pageSize: globalTake, SortOrder: "ASC", SortBy: "applyDate", requestFromDate, requestToDate }
        getPendingForApprovalKys2List(params);

        const searchInput = document.querySelector(".table-search");
        if (searchInput) {
            searchInput.value = ""; // Clear the input value
        }
        setTimeout(() => {
            let date = document.querySelector(".ag-date-filter input");
            date.value = requestDateFilter?.dateFrom.replace(" 00:00:00", "");
        }, 1000);
    };

    function formatDateHavells(dateString) {
        if (dateString) {
            const date = new Date(dateString);
            // Format the date as needed, for example: DD/MM/YYYY
            const formattedDate = `${date.getDate()}-${date.getMonth() + 1
                }-${date.getFullYear()}`;
            return formattedDate;
        }
        return null;
    }

    const onSortChanged = (event) => {
        const sortModel = event.api.getSortModel();

        if (sortModel.length > 0) {
            const { colId, sort } = sortModel[0];
            const sortOrder = sort === "asc" ? "ASC" : "DESC";

            let params = { pageNo, pageSize: globalTake, SortOrder: sortOrder, SortBy: colId }
            getPendingForApprovalKys2List(params);
        } else {
            // Handle the case where there is no sorting
            let params = { pageNo, pageSize: globalTake, SortOrder: "ASC", SortBy: null }
            getPendingForApprovalKys2List(params);
        }
    };

    const handleSearchTextChange = (e) => {
        const newFilter = {
            supplierName: e.target.value,
        };
        setFilter(newFilter);
        // Fetch data with the updated filter and reset to the first page
        let params = { pageNo: 1, pageSize: globalTake, SortOrder: "ASC", SearchText: newFilter?.supplierName }
        getPendingForApprovalKys2List(params);
        setNoData(false);
        setCurrentRowIndex(0);
        gridOptions?.columnApi?.resetColumnState();
        setPageNo(1);
        setCurrentRowIndex(0);
    };

    const handleResetGrid = (params) => {
        // Reset filters
        if (gridApi) {
            gridApi.setFilterModel(null); // Reset filters
            gridApi.setSortModel(null); // Reset sorting
            setTimeout(() => {
                window.screen.width >= 1366 && params.api.sizeColumnsToFit();
            }, 100);
        }
        // Reset column state
        if (gridColumnApi) {
            gridColumnApi.resetColumnState(); // Reset column state
            setTimeout(() => {
                window.screen.width >= 1366 && params.api.sizeColumnsToFit();
            }, 100);
        }
        // Clear the input field
        const searchInput = document.querySelector(".table-search");
        if (searchInput) {
            searchInput.value = ""; // Clear the input value
            setTimeout(() => {
                window.screen.width >= 1366 && params.api.sizeColumnsToFit();
            }, 100);
        }
        // Reset pagination
        setPageNo(1); // Reset the pageNo state variable to 1
        // Fetch data with default parameters
        window.location.reload();
        let apiParams = { pageNo: pageNo, pageSize: defaultPageSize, SortOrder: "ASC", SortOrder: "applyDate" };
        getPendingForApprovalKys2List(apiParams);
        setTimeout(() => {
            window.screen.width >= 1366 && params.api.sizeColumnsToFit();
        }, 400);
    };

    const history = useHistory();

    const isFirstColumn = (params) => {
        var displayedColumns = params.columnApi.getAllDisplayedColumns();
        var thisIsFirstColumn = displayedColumns[0] === params.column;

        if (props?.isMasterSummaryDrawer) {
            return false;
        } else {
            return thisIsFirstColumn;
        }
    };
    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        // headerCheckboxSelection:
        //   isSimulation || props?.benchMark ? isFirstColumn : false,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: isFirstColumn,
    };
    const onGridReady = (params) => {
        setGridApi(params.api);
        params.api.sizeColumnsToFit();
        setGridColumnApi(params.columnApi);
        params.api.paginationGoToPage(0);
        const checkBoxInstance = document.querySelectorAll(
            ".ag-input-field-input.ag-checkbox-input"
        );
        checkBoxInstance.forEach((checkBox, index) => {
            const specificId = `RM_Domestic_Checkbox${index / 11}`;
            checkBox.id = specificId;
        });
        const floatingFilterInstances = document.querySelectorAll(
            ".ag-input-field-input.ag-text-field-input"
        );
        floatingFilterInstances.forEach((floatingFilter, index) => {
            const specificId = `RM_Domestic_Floating${index}`;
            floatingFilter.id = specificId;
        });
        setTimeout(() => {
            window.screen.width >= 1366 && params.api.sizeColumnsToFit();
        }, 400);
    };

    const onPageSizeChanged = (newPageSize) => {
        const pageSizeValue = Number(newPageSize);

        if (![10, 50, 100].includes(pageSizeValue)) {
            return; // Don't proceed if the page size is not valid
        }

        // Reset the page number to 1
        setPageNo(1);

        // Calculate the new page number based on the total record count and the new page size
        let newPageNo = 1;

        // Make the API call with the new page size and updated page number
        let params = { pageNo: newPageNo, pageSize: pageSizeValue };
        getPendingForApprovalKys2List(params);

        // Update the state to reflect the new page size
        setPageSize({
            pageSize10: pageSizeValue === 10,
            pageSize50: pageSizeValue === 50,
            pageSize100: pageSizeValue === 100,
        });

        setGlobalTake(pageSizeValue);

        // Update the grid's page size
        gridApi.paginationSetPageSize(pageSizeValue);
    };

    const buttonFormatter = (props) => {
        props.api.sizeColumnsToFit();
        const handleView = () => {
            reactLocalStorage.setObject('receiverId', props.data?.ReceiverId)
            const requestId = props.data?.VendorRequirementRegistrationId;
            history.push(
                `view-supplier-need-form?VendorRequirementRegistrationId=${requestId}`
            );
        };
        const handleEdit = () => {
            // Handle edit action
            history.push(
                `/supplier-need-form?VendorRequirementRegistrationId=${props?.data?.VendorRequirementRegistrationId}&mode=edit`
            );
        };

        return (
            <div>
                {(permissionsKys2?.View || props?.data?.IsDelegated) && 
                    <button
                        title="View"
                        className="View mr-2"
                        type="button"
                        onClick={handleView}
                    >
                    </button>}
                {(permissionsKys2?.Edit && !props?.data?.IsDelegated) && 
                    <button
                        title="Edit"
                        className="Edit mr-2"
                        type="button"
                        disabled={props.data.currentLevel > 1}
                        onClick={handleEdit}
                    >
                    </button>}
            </div>
        );
    };

    const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
        return (
            <>
                <label htmlFor="normal-switch" className="normal-switch">
                    <Switch
                        // onChange={() => handleSearchTextChange(cell, row, enumObject,1 rowIndex)}
                        checked={cell}
                        background="#ff6600"
                        onColor="#4DC771"
                        onHandleColor="#ffffff"
                        id="normal-switch"
                        height={24}
                    />
                </label>
            </>
        );
    };
    const onRowSelect = (event) => {
        let selectedRowForPagination =
            reactLocalStorage.getObject("selectedRow").selectedRow;
        // 

        var selectedRows = gridApi && gridApi?.getSelectedRows();
        if (selectedRows === undefined || selectedRows === null) {
            //CONDITION FOR FIRST RENDERING OF COMPONENT
            selectedRows = selectedRowForPagination;
        } else if (
            selectedRowForPagination &&
            selectedRowForPagination.length > 0
        ) {
            // CHECKING IF REDUCER HAS DATA

            let finalData = [];
            if (event.node.isSelected() === false) {
                // CHECKING IF CURRENT CHECKBOX IS UNSELECTED

                for (let i = 0; i < selectedRowForPagination.length; i++) {
                    if (
                        selectedRowForPagination[i].applicationNo ===
                        event.data.applicationNo
                    ) {
                        // REMOVING UNSELECTED CHECKBOX DATA FROM REDUCER
                        continue;
                    }
                    finalData.push(selectedRowForPagination[i]);
                }
            } else {
                finalData = selectedRowForPagination;
            }
            selectedRows = [...selectedRows, ...finalData];
        }

        let uniqeArray = _.uniqBy(selectedRows, "applicationNo"); //UNIQBY FUNCTION IS USED TO FIND THE UNIQUE ELEMENTS & DELETE DUPLICATE ENTRY
        reactLocalStorage.setObject("selectedRow", { selectedRow: uniqeArray }); //SETTING CHECKBOX STATE DATA IN LOCAL STORAGE
        setDataCount(uniqeArray.length);
        dispatch(setSelectedRowForPagination(uniqeArray));
        let finalArr = selectedRows;
        let length = finalArr?.length;
        let uniqueArray = _.uniqBy(finalArr, "applicationNo");

        // if (isSimulation) {
        //   apply(uniqueArray, length);
        // }

        if (props?.benchMark) {
            let uniqueArrayNew = _.uniqBy(selectedRows, (v) =>
                [v.TechnologyId, v.RawMaterial].join()
            );

            if (uniqueArrayNew.length > 1) {
                dispatch(setSelectedRowForPagination([]));
                gridApi.deselectAll();
                Toaster.warning("Technology & Raw material should be same");
            }
        }
    };
    const effectiveDateFormatter = (props) => {
        const cellValue = props?.valueFormatted
            ? props.valueFormatted
            : props?.value;
        return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
    };
    const checkBoxRenderer = (props) => {
        let selectedRowForPagination =
            reactLocalStorage.getObject("selectedRow").selectedRow;

        const cellValue = props?.valueFormatted
            ? props.valueFormatted
            : props?.value;
        if (selectedRowForPagination?.length > 0) {
            selectedRowForPagination.map((item) => {
                if (
                    item.applicationNo ===
                    props.node.data.applicationNo
                ) {
                    props.node.setSelected(true);
                }
                return null;
            });
            return cellValue;
        } else {
            return cellValue;
        }
    };
    /**
     * @method effectiveDateFormatter
     * @description Renders buttons
     */

    const frameworkComponents = {
        totalValueRenderer: buttonFormatter,
        customFloatingFilter: CustomDateRangeFilter,
        statusButtonFormatter: statusButtonFormatter,
        effectiveDateFormatter: effectiveDateFormatter,
        // hyphenFormatter: hyphenFormatter,
        customNoRowsOverlay: NoContentFound,
        checkBoxRenderer: checkBoxRenderer,
        // valuesFloatingFilter: SingleDropdownFloationFilter,
    };
    /**
     * @method statusButtonFormatter
     * @description Renders buttons
     */

    return (
        <>
            <>
                {pageLoader && <LoaderCustom customClass="simulation-Loader" />}
                <>
                    {/* <Row className={`filter-row-large`}>
                        <Col md="12" className="mb-2">
                            <h1>Pending For Approval - KYS2</h1>
                        </Col>
                    </Row> */}
                    <Row className="ag-grid-react custom-pagination">
                        <Col>
                            <div className={`ag-grid-wrapper overlay-contain`} >
                                <div className={`ag-theme-material ${pageLoader && "max-loader-height"}`}>
                                    {noData && (
                                        <NoContentFound
                                            title={EMPTY_DATA}
                                            customClassName="no-content-found"
                                        />
                                    )}
                                    <Row className={`filter-row-large mt-3`}>
                                        <Col md="3" className="mb-2">
                                            {/* <input
                                                type="text"
                                                className="form-control table-search"
                                                placeholder="Search"
                                                autoComplete={"off"}
                                                onChange={handleSearchTextChange}
                                            /> */}
                                        </Col>
                                        <Col md="9" className="mb-3 d-flex justify-content-end">
                                            <div className="d-flex justify-content-end bd-highlight w100">
                                                <>
                                                    {/* {
                                                        permissionsKys2?.Download &&
                                                        <button
                                                            type="button"
                                                            className="user-btn mr5"
                                                            title="Download All"
                                                            onClick={handleExcelDownload}
                                                        >
                                                            <div className="download mr-1"></div>All
                                                        </button>
                                                    } */}
                                                    <button
                                                        type="button"
                                                        className="user-btn"
                                                        title="Reset Grid"
                                                        onClick={() => handleResetGrid()}
                                                    >
                                                        <div className="refresh mr-0"></div>
                                                    </button>
                                                </>
                                            </div>
                                        </Col>
                                    </Row>
                                    <AgGridReact
                                        defaultColDef={defaultColDef}
                                        floatingFilter={true}
                                        domLayout="autoHeight"
                                        // rowData={usersWithSerialNumbers}
                                        rowData={pendingForApprovalKys2ListData?.Data}
                                        onFilterChanged={onFilterChanged}
                                        pagination={false}
                                        onRowSelected={onRowSelect}
                                        paginationPageSize={globalTake}
                                        onGridReady={onGridReady}
                                        gridOptions={gridOptions}
                                        noRowsOverlayComponent={"customNoRowsOverlay"}
                                        onSortChanged={onSortChanged}
                                        noRowsOverlayComponentParams={{
                                            title: EMPTY_DATA,
                                            imagClass: "imagClass",
                                        }}
                                        frameworkComponents={frameworkComponents}
                                        rowSelection={"multiple"}
                                        suppressRowClickSelection={true}
                                        enableBrowserTooltips={true}
                                    >
                                        <AgGridColumn
                                            cellClass="has-checkbox"
                                            field="VendorRequirementRegistrationApplicationNo"
                                            headerName="Application No."
                                            cellRenderer={checkBoxRenderer}
                                            floatingFilter={false}
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="SupplierCategory"
                                            sortable={true}
                                            unSortIcon={true}
                                            filter={true}
                                            floatingFilter={true}
                                            headerName="Supplier Category"
                                            comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                                valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                            }
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="SupplierName"
                                            headerName="Supplier Name"
                                            floatingFilter={true}
                                            sortable={true}
                                            unSortIcon={true}
                                            comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                                valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                            }
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="PlantName"
                                            floatingFilter={true}
                                            sortable={true}
                                            unSortIcon={true}
                                            headerName="Plant"
                                            comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                                valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                            }
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="ActionDate"
                                            headerName="Apply Date"
                                            filter="agDateColumnFilter"
                                            cellRenderer={"effectiveDateFormatter"}
                                            filterParams={{
                                                date: "",
                                                inRangeInclusive: true,
                                                filterOptions: ["equals", "inRange"],
                                                browserDatePicker: true,
                                                minValidYear: 2000,
                                            }}
                                            floatingFilterComponentParams={{
                                                suppressFilterButton: true, // Optional parameters for your custom filter component
                                            }}
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="RequestedBy"
                                            floatingFilter={true}
                                            sortable={false}
                                            headerName="Requested By"
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="Status"
                                            sortable={false}
                                            floatingFilter={true}
                                            headerName="Status"
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            headerName="Actions"
                                            sortable={false}
                                            cellRenderer={"totalValueRenderer"}
                                            type="rightAligned"
                                            floatingFilter={false}
                                        ></AgGridColumn>
                                    </AgGridReact>
                                    {/* Add a new AgGridColumn for buttons */}
                                    <div className="button-wrapper">
                                        {
                                            <PaginationWrapper
                                                gridApi={gridApi}
                                                setPage={onPageSizeChanged}
                                                globalTake={globalTake}
                                            />
                                        }
                                        {(props?.isMasterSummaryDrawer === undefined ||
                                            props?.isMasterSummaryDrawer === false) && (
                                                <div className="d-flex pagination-button-container">
                                                    <p>
                                                        <Button
                                                            // id="rmDomesticListing_previous"
                                                            variant="previous-btn"
                                                            onClick={() => onBtPrevious()}
                                                        />
                                                    </p>
                                                    <p className="next-page-pg custom-left-arrow">
                                                        Page <span className="text-primary">{pageNo}  </span> of {pendingForApprovalKys2ListData?.TotalPages}
                                                    </p>
                                                    <p>
                                                        <Button
                                                            id="rmDomesticListing_next"
                                                            variant="next-btn"
                                                            onClick={() => onBtNext()}
                                                        />
                                                    </p>
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </>
            </>
        </>
    );
};
export default PendingForApprovalKys2ListTab;
